import {observer} from 'mobx-react';
import React from 'react';
import Store from '../../stores/store';
import {observable, toJS} from 'mobx';
import {I18n} from '../../i18n/i18n';
import {ISO_4217_CURRENCY_CODES} from '../../utility/Currencies';
import {classes, stylesheet} from 'typestyle';
import _ from 'lodash';
import {Channel} from '../../types/Channel';
import {WhiteColor, BlueColor} from '../../styles/colors';

@observer
export default class CurrencySetting extends React.Component<{store: Store}> {
    @observable private currenciesPerChannel = this.getChannelsWithCurrencies();

    private saveChangesToCurrency = () => {
        this.props.store.channelStore.setCurrenciesForChannel(this.currenciesPerChannel);
    };

    private getChannelsWithCurrencies(): Channel[] {
        return this.props.store.channelStore.availableChannels;
    }

    private changeCurrencyForChannel(channelName: string, newCurrency: string) {
        this.currenciesPerChannel = this.currenciesPerChannel.map((currencyAndChannel) => ({
            name: currencyAndChannel.name,
            currency: channelName === currencyAndChannel.name ? newCurrency : currencyAndChannel.currency,
        }));
    }

    private saveableDataIsPresent(): boolean {
        return !_.isEqual(toJS(this.currenciesPerChannel), toJS(this.getChannelsWithCurrencies()));
    }

    public render() {
        return (
            <div>
                <div className={currencyCss.description}>
                    <I18n i18nKey="currency.settingDescription" />
                </div>
                <div className={currencyCss.row}>
                    <div className={classes(currencyCss.heading, currencyCss.rowItem)}>
                        <I18n i18nKey="table:channel" />
                    </div>
                    <div className={classes(currencyCss.heading, currencyCss.rowItem)}>
                        <I18n i18nKey="currency.channelCurrencies" />
                    </div>
                </div>
                {this.currenciesPerChannel.map((currencyAndChannel) => (
                    <div key={currencyAndChannel.name} className={currencyCss.row}>
                        <div className={currencyCss.rowItem}>{currencyAndChannel.name}</div>
                        <div className={currencyCss.rowItem}>
                            <select
                                className={currencyCss.select}
                                value={currencyAndChannel.currency}
                                onChange={(e) => this.changeCurrencyForChannel(currencyAndChannel.name, e.currentTarget.value)}>
                                {ISO_4217_CURRENCY_CODES.map((currency) => (
                                    <option key={currency}>{currency}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                ))}
                {this.saveableDataIsPresent() ? (
                    <div className={currencyCss.buttonRow}>
                        <button className={classes(currencyCss.baseButton, currencyCss.saveButton)} onClick={this.saveChangesToCurrency}>
                            <I18n i18nKey="data.save" />
                        </button>
                    </div>
                ) : null}
            </div>
        );
    }
}

const currencyCss = stylesheet({
    buttonRow: {
        float: 'right',
        marginTop: 10,
    },
    description: {
        fontSize: 13,
        marginLeft: 5,
    },
    select: {
        width: '100%',
        height: 30,
    },
    heading: {
        fontWeight: 'bold',
        fontSize: 13,
    },
    rowItem: {
        flex: 1,
        padding: '5px 0px 5px 5px',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        padding: '5px 0px 5px, 5px',
    },
    saveButton: {
        backgroundColor: BlueColor,
    },
    baseButton: {
        paddingLeft: 15,
        paddingRight: 15,
        border: 'none',
        color: WhiteColor,
        height: 30,
    },
});



// WEBPACK FOOTER //
// ./src/views/Setting/CurrencySetting.tsx